export default "__VITE_ASSET__4bd8893e__"